export default __webpack_public_path__ + "3e3eea3b7c6b5dd7904649a8b95d65b3.png";